import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=9673a154&scoped=true&"
import script from "./PointHistory.vue?vue&type=script&lang=js&"
export * from "./PointHistory.vue?vue&type=script&lang=js&"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=9673a154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673a154",
  null
  
)

export default component.exports